import * as React from 'react';
import { Route } from 'react-router';

import CareerPlansApp from 'bundles/career-plans/components/CareerPlansApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const CareerPlansPageDynamic = loadOnRoute(() => import('bundles/career-plans/components/CareerPlansPage'));

export default (
  <Route path="/" component={CareerPlansApp}>
    <Route path="career-plans/:slug" getComponent={CareerPlansPageDynamic} />
    <Route path="learning-path/:slug" getComponent={CareerPlansPageDynamic} />
    <Route path="learning-paths/:slug" getComponent={CareerPlansPageDynamic} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
